<template>
    <div class="loginBox">
        <div id="login">
            <h1>{{ $t('app.name') }}</h1>
            <input type="text" v-model="loginData.username" required="required" :placeholder="$t('user.username')"
                name="u"></input>
            <input type="password" v-model="loginData.password" required="required" :placeholder="$t('user.password')"
                name="p"></input>
            <el-checkbox v-model="rememberMe" style="text-align:center;margin:0 0 25px 112px;">{{ $t('user.rememberMe')
                }}</el-checkbox>
            <!-- <el-button class="but" type="primary" @click="login">{{$t('user.login')}}</el-button> -->
            <!-- y230703 -->
            <el-button class="but" type="primary" :loading="loading" @click="login">
                <span v-if="!loading">{{ $t('user.login') }}</span>
                <span v-else>{{ $t('user.loginLoading') }}</span>
            </el-button>
        </div>
        <el-dialog title="" :visible.sync="dialogVisible" width="60%">
            <el-row style=" margin-bottom: 10px;" v-for="(itemList, i)  in appList" :key="i">
                <el-col :span="4" v-for="(item, j) in itemList" :key="j">
                    <div class="item_select" style="text-align:center"
                        @click="handlerAppSelect(item.tenantCode, item.appTenantCode)">
                        <img class="item-img" width="120px" :src='item.appIcon' alt="">
                        <p class="item-desc">{{ item.name }}</p>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
//y230521 add remember me function
import {
    getPassword, getRememberMe, getUsername,
    removePassword, removeRememberMe, removeUsername,
    setPassword, setRememberMe, setUsername, setTenantCode
} from "@/utils/myAuth";

export default {
    data() {
        return {
            loginData: {
                // username:"kinglumi",
                // password:"123456",
                username: "",
                password: ""
            },
            //y230521
            rememberMe: false,
            //y230703
            loading: false,
            dialogVisible: false,
            appList: [],
            appTenantCodeList: []
        }
    },
    watch: {
        appTenantCodeList() {
            //当数据有变化时，进行数据的更新 y240313
            let tmpList = [];
            let tempItem = {};
            this.appList = [];
            for (let k = 0; k < this.appTenantCodeList.length; k++) {
                if (k % 6 == 0) {
                    if (k == 0) {
                        tmpList = [];
                    } else {
                        this.appList.push(tmpList);
                        tmpList = [];
                    }
                }
                tempItem = {};
                tempItem['name'] = this.appTenantCodeList[k].appName;
                // tempItem['appIcon'] = require(`@/assets/img_240313/${this.appTenantCodeList[k].name}.png`);
                tempItem['tenantCode'] = this.appTenantCodeList[k].tenantCode;
                tempItem['appTenantCode'] = this.appTenantCodeList[k].appTenantCode;

                try {
                    tempItem['appIcon'] = require(`@/assets/img_240313/${this.appTenantCodeList[k].name}.png`);
                } catch (error) {
                    continue;
                }

                tmpList.push(tempItem);
            }
            if (tmpList.length > 0) {
                this.appList.push(tmpList);
            }

            if (this.appList.length > 0) {
                if (this.appList[0].length == 1) {
                    //如果最后只有一个选项，则直接进行默认选择而登录
                    this.handlerAppSelect(this.appList[0][0].tenantCode, this.appList[0][0].appTenantCode);
                } else {
                    //如果有多个选择，则进行选择。打开对话框 y240318
                    this.dialogVisible = true;
                }
            }

        }
    },
    methods: {
        //y230521 remember me 
        getCookie() {
            const username = getUsername();
            const password = getPassword();
            const rememberMe = getRememberMe();
            // const tenantName = getTenantName();
            this.loginData = {
                ...this.loginData,
                username: username ? username : this.loginData.username,
                password: password ? password : this.loginData.password,
            };
            this.rememberMe = rememberMe ? getRememberMe() : false
        },
        login() {
            //y230703
            this.loading = true;
            // 设置 Cookie y230521
            if (this.rememberMe) {
                setUsername(this.loginData.username)
                setPassword(this.loginData.password)
                setRememberMe(this.rememberMe)
                // setTenantName(this.loginForm.tenantName)
            } else {
                removeUsername()
                removePassword()
                removeRememberMe()
                // removeTenantName()
            }
            this.$post("auth/login", this.loginData).then(res => {
                //如果返回为555，多个平台都有账户，需要先选择一个平台 则进行登录用户的选择 y240315
                if (res && res.code == 555) {

                    this.loading = false;
                    // this.dialogVisible = true;
                    //进行数据请求 y240312
                    let myObj = {};
                    myObj['username'] = this.loginData.username;
                    // myObj['areacode'] = res.data.userInfo.tenanttype;
                    this.$post("v2/saas/app/user/query_user_multiaccount", myObj).then(res => {
                        if (res && res.data) {
                            // this.appTenantCodeList = res.data;
                            // this.appTenantCodeList = ["CN2304201S","BE2304200S","NL2204280S","US2311270S"];
                            this.appTenantCodeList = res.data;

                        }
                    })
                } else {
                    this.$setToken(res.data.token, res.data.nickname)
                    this.$setUsername(res.data.userInfo == null ? "" : res.data.userInfo.username)
                    if (res && res.data && res.data && res.data.userInfo && res.data.userInfo.tenanttype) {
                        this.$setTenantType(res.data.userInfo.tenanttype)
                        this.$setTenantLogin(res.data.userInfo == null ? "saas" : res.data.userInfo.tenantLogin ? res.data.userInfo.tenantLogin : "saas")
                    } else if (res && res.data && res.data && res.data.userInfo && res.data.userInfo.areacode &&
                        res.data.userInfo.areacode.length > 9) {
                        //substr() 方法返回的子串从 start 处的字符开始(包括)往后截取length长度，如果超过最末端就到最末端结束
                        this.$setTenantType(res.data.userInfo == null ? "" : res.data.userInfo.areacode.substr(0, 9));
                        this.$setTenantLogin("store_manager");
                    }
                    //york230422,setTenantType
                    // this.$setTenantType(res.data.userInfo==null?"":res.data.userInfo.tenanttype)
                    //y230521 setTenantCode
                    this.$setTenantCode(res.data.userInfo == null ? "saas" : res.data.userInfo.areacode)
                    //y230627
                    //this.$setTenantLogin(res.data.userInfo==null?"saas":res.data.userInfo.tenantLogin?res.data.userInfo.tenantLogin:"saas")

                    //y230703 设置用户信息
                    this.$store.dispatch("SaasSetUserInfo", res.data.userInfo);


                    //y230627
                    //this.$router.push({path:'/messageList'})
                    //如果是APP的店长用户登录，则跳转到商店列表页面
                    if (this.$getTenantLogin() == 'store_manager') {
                        //y230703 y240516
                        let myObj = {};
                        myObj['username'] = res.data.userInfo.username;
                        // myObj['areacode'] = res.data.userInfo.tenanttype;
                        myObj['areacode'] = this.$getTenantType();


                        this.$post("v2/saas/app/user/find_app_user", myObj).then(res => {
                            if (res && res.data && res.data.id) {
                                //this.$setTenantLogin(this.$getTenantLogin()+"@@"+res.data.id)
                                this.$setTenantLogin("store_manager@@" + res.data.id)
                            }
                            this.tableData = res.data ? res.data : []
                            this.count = res.total ? Number(res.total) : 0
                        })

                        // this.$router.push({path:'/meshManage'})
                        // this.$router.replace({ path: '/meshManage' })
                        // location.reload();
                    } else if (res && res.data && res.data.userInfo && res.data.userInfo.tenantLogin == 'cmc_iot') {
                        //y240318 
                        // this.$router.replace({path:'/hardwareList'})
                        // this.$router.replace({ path: '/meshManage' })

                    } else {
                        // this.$router.push({path:'/messageList'})
                        // this.$router.replace({path:'/messageList'})
                        //240318
                        // this.$router.replace({ path: '/meshManage' })
                        // location.reload();
                    }
                    this.$router.push({ path: '/' })
                }
            }).catch(() => {
                //y240314 登陆失败，清除登录选择信息
                this.$setTenantCode("saas");
                this.loading = false;
                // if (this.captchaEnabled) {
                //   this.getCode();
                // }
            });
        },
        //监听回车键执行事件 york230427
        keyDown(e) {
            //enter key for logging in. enter key's ascii is 13
            if (e.keyCode === 13) {
                //to do login method. york230427
                this.login()
            }
        },
        handlerAppSelect(tenantCode, appTenantCode) {
            this.$setTenantCode(tenantCode);
            this.dialogVisible = false;
            this.login();
        }
    },
    //bind the system listen event
    mounted() {
        window.addEventListener('keydown', this.keyDown);
        //y230521 add remember me function
        this.getCookie();
        //y240314 清除登录信息
        this.$setTenantCode("saas");
    },
    //destroy the event
    destroyed() {
        window.removeEventListener('keydown', this.keyDown, false)
    }
}
</script>
<style scoped>
.loginBox {
    width: 100%;
    height: 100vh;
    background: #f0f0f0;
    background: url('~@/assets/u0.jpg') no-repeat 100% 100%;
    background-size: 100% 100%;
}

#login {
    position: absolute;
    top: 50%;
    left: 47%;
    margin: -250px 0 0 -250px;
    width: 622px;
    height: 360px;
    border: 1px solid #f0f0f0;
    border-radius: 5px;
    padding: 0 50px;
    background-color: #fff;
}

#login h1 {
    color: #333;
    text-shadow: 0 0 10px;
    letter-spacing: 1px;
    text-align: center;
    padding-top: 22px;
    padding-bottom: 22px;
}

h1 {
    font-size: 2em;
    margin: 0.67em 0;
}

input {
    width: 278px;
    height: 18px;
    margin: auto;
    display: block;
    margin-bottom: 20px;
    outline: none;
    padding: 10px;
    font-size: 13px;
    color: #333;
    text-shadow: 1px 1px 1px;
    border-top: 1px solid #312E3D;
    border-left: 1px solid #312E3D;
    border-right: 1px solid #312E3D;
    border-bottom: 1px solid #56536A;
    border-radius: 4px;
    background-color: #fff;
    /*background-color: #2D2D3F;*/
}

.but {
    width: 300px;
    min-height: 20px;
    margin: auto;
    display: block;
    color: #fff;
    padding: 9px 14px;
    font-size: 15px;
    line-height: normal;
    border-radius: 5px;
}

.item_select:hover {
    background-color: #2223;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    border-radius: 4px;
    border: 1px solid #ebeef5;
}
</style>